var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3970_13712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 0H3C1.34 0 0 1.34 0 3V13C0 14.66 1.34 16 3 16H19C20.66 16 22 14.66 22 13V3C22 1.34 20.66 0 19 0ZM6.17 11.15H3.37C2.87 11.15 2.44 10.75 2.44 10.22V4.85H3.54V10.02C3.54 10.1 3.6 10.16 3.68 10.16H6.16V11.15H6.17ZM8.01 11.15H6.91V4.85H8.01V11.15ZM12.21 11.15H10.83L8.62 4.85H9.78L11.06 8.72C11.16 9.02 11.35 9.58 11.52 10.04C11.69 9.58 11.88 9.02 11.98 8.72L13.26 4.85H14.42L12.21 11.15ZM19.56 11.15H15.75C15.25 11.15 14.82 10.75 14.82 10.22V5.77C14.82 5.24 15.24 4.84 15.75 4.84H19.4V5.83H16.07C15.99 5.83 15.93 5.89 15.93 5.97V7.31H19.2V8.3H15.93V9.99C15.93 10.07 15.99 10.13 16.07 10.13H19.56V11.12V11.15Z",
    fill: "#3462FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3970_13712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLive);
export default __webpack_public_path__ + "static/media/icon-live.e551cb2c462d1aaa3b49f82fc008ff28.svg";
export { ForwardRef as ReactComponent };